import { get } from './client';
import { buildPath, toJson } from './utils';
import { COUNTRIES } from './constants';
import { Country } from './general/models';

export const getCountries = (options: any): Promise<Country[]> => get(buildPath(COUNTRIES), options).then(toJson);
